exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-fe-handle-dialog {\n  display: block;\n  width: 700px;\n}\n\n/* --- Mobile --- */\n@media only screen and (max-width: 768px) {\n  fi-fe-handle-dialog {\n    width: 100%;\n  }\n  .fi-dialog .fi-dialog-content {\n    /* Image */\n  }\n  .fi-dialog .fi-dialog-content .fi-dialog-content-img {\n    width: 100%;\n    height: 275px;\n    margin-right: 0;\n  }\n  .fi-dialog .fi-dialog-content .fi-dialog-content-thumbnails {\n    width: 100%;\n  }\n}", ""]);

// exports
